package com.exura.features.userprofile.data.mappers

import com.exura.features.userprofile.data.remote.dto.OrganizationProfileDto
import com.exura.features.userprofile.domain.model.OrganizationProfile
import dev.gitlive.firebase.firestore.CollectionReference

class OrganizationProfileMappers : ProviderUserSettingsMappers<OrganizationProfile, OrganizationProfileDto> {
    override fun toDto(model: OrganizationProfile): OrganizationProfileDto = OrganizationProfileDto(
        email = model.email,
        name = model.name,
        field = model.field,
        patientsContactNumber = model.patientsContactNumber
    )

    override fun toDomain(dto: OrganizationProfileDto, collection: CollectionReference?, id: String?): OrganizationProfile = OrganizationProfile(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        email = dto.email,
        name = dto.name,
        field = dto.field,
        patientsContactNumber = dto.patientsContactNumber
    )
}
